import * as React from 'react';
import { FelaComponent } from 'react-fela';
import { withUIETheme } from '../uietheme/withUIETheme';
const ColorPanel = ({ color, uieTheme }) => {
    const style = {
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        minWidth: '5rem',
        height: '5rem',
        backgroundColor: color,
        padding: uieTheme.spacing.space1,
        marginRight: uieTheme.spacing.space1,
        marginBottom: uieTheme.spacing.space1,
        borderRadius: '3px',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: uieTheme.colors.borderPanel,
    };
    return React.createElement(FelaComponent, { style: style });
};
export const SmallColorPanel = withUIETheme(ColorPanel);
//# sourceMappingURL=SmallColorPanel.js.map